import Box from '@mui/material/Box';
import { FC, Fragment } from 'react';
import separetor from 'atoms/icons/svg/breadcrumb-seperator.svg';
import useMobile from 'hooks/useMobile';
import SiteDropdown from 'components/Sites/Dropdown';
import { ReactComponent as ThreeDotsIcon } from 'atoms/icons/svg/threedots.svg';
import './HeaderBreadCrumb.scss';

type Props = {
  items: {
    label: string;
  }[];
};

const HeaderBreadCrumb: FC<Props> = ({ items }) => {
  const { isMobile } = useMobile();

  return (
    <Box
      sx={{
        bgcolor: 'transparent',
      }}
    >
      <div className="breadcrumbs-wrapper">
        <div className="breadcrumbs">
          {isMobile && (
            <SiteDropdown
              clickableNodeOverride={
                <ThreeDotsIcon className="mobile-threedot" />
              }
            />
          )}

          {items.map(({ label }, index) => {
            return (
              <Fragment key={label}>
                {!!index && <img src={separetor} alt="separetor" />}
                <div className="breadcrumb-item">{label}</div>
              </Fragment>
            );
          })}
        </div>
      </div>
    </Box>
  );
};

export default HeaderBreadCrumb;
